import { AuthenticateWithRedirectCallback } from "@clerk/tanstack-react-start";
import { createFileRoute } from "@tanstack/react-router";

/**
 * Orcaloops sign-up OAuth (SSO) return route — completes the Clerk social
 * round-trip for `<SignUp routing="path">` at `/orca/sign-up`.
 *
 * Both fallbacks are pinned to `/orca` (the internal orca root, rendered as `/`
 * on orcaloops.ai) because Clerk honors the redirect's `redirectUrlComplete` on
 * a fresh sign-up but DROPS it on a sign-up→sign-in transfer — an already-known
 * social identity — falling back to the callback's fallback props (see the same
 * note at `routes/clawinstall/login/sso-callback.tsx`). Without them the
 * transfer case dead-ends on Clerk's own default destination.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/orca/sign-up/sso-callback")({
  component: OrcaSignUpSSOCallback,
});

export function OrcaSignUpSSOCallback() {
  return (
    <AuthenticateWithRedirectCallback
      signInFallbackRedirectUrl="/orca"
      signUpFallbackRedirectUrl="/orca"
    />
  );
}
